import React from "react";
import { CreateTitle } from "./FormPage/index.content";
import { ANALYTICS_CATEGORY } from "../../helpers/constants";

export const BANNER_REDIRECT_URL =
  "https://chromewebstore.google.com/detail/amazon-product-finder-amz/cdmbeofnbhgdgnijieodggfmfpamfifg?utm_source=site&utm_medium=amzscout&utm_campaign=main_banner_es";

export const URL_LABEL = "r=es";

export const CENTER_OPTIONS_FORM = {
  redirectButton: {
    category: ANALYTICS_CATEGORY.ES,
  },
};
export const BOTTOM_OPTIONS_FORM = {
  title: <CreateTitle title="¡Encuentra productos rentables en Amazon con una PRUEBA GRATIS ahora!" />,
  customClass: "PgESM-FP_formBottom",
  redirectButton: {
    category: ANALYTICS_CATEGORY.ES,
  },
};

export const KEYWORDS = [
  "vender en amazon",
  "productos mas vendidos (productos más vendidos)",
  "vender productos",
  "productos en amazon",
  "empezar",
  "rentable",
  "productos para vender",
  "vender cosas",
  "herramientas para vender en amazon",
  "encontrar",
  "mas buscados",
  "buscar",
  "analizador de productos",
  "como vender en amazon (cómo vender en amazon)",
  "que vender en amazon",
  "que productos se venden mas"
];